import React from 'react';
import Hero from "../../src/Components/Hero/Hero";
import Welcome from '../Components/Welcome/Welcome';

function Home() {
  return (
    <>
      <Hero />

<pre>
{`const ta = document.querySelector('textarea');
ta.value = 'A';
ta.dispatchEvent(new Event('input', { bubbles: true }));`}
</pre>

      <Welcome />
    </>
  );
}

export default Home;
